import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { int2ip } from "../../../helpers/helpers";
import { logEventList } from "../../../pages/logs/logsTypeData";
import { useGetPageQuery, useSendFormMutation } from "../../../redux/services/crmAPI";
import LoadingModal from "../../loadingModal/LoadingModal";

const ModalProductInfo = ({ setShowProductModal, showProductModal, dataForModal }) => {
    const userPermission = useSelector((state) => state.status.userPermission);
    const canManageProductComments = +userPermission?.user_permission_type_id === 9;
    const { data: product, refetch: refetchProduct } = useGetPageQuery(`products/${dataForModal?.id}?services=1`, {
        skip: !dataForModal?.id,
    });
    const [sendForm, { isLoading }] = useSendFormMutation();

    const handleClose = () => setShowProductModal(false);
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState("");
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editingCommentText, setEditingCommentText] = useState("");

    useEffect(() => {
        if (product) {
            setComments(product.comments ?? []);
        }
    }, [product]);

    const addCommentHandler = async () => {
        const trimmedComment = comment.trim();

        if (!trimmedComment) {
            return;
        }

        await sendForm({
            body: { text: trimmedComment },
            url: `products/${dataForModal.id}/comments?services=1`,
            method: "POST",
        }).unwrap();
        await refetchProduct();
        setComment("");
    };

    const startEditCommentHandler = (comment) => {
        setEditingCommentId(comment.id);
        setEditingCommentText(comment.text ?? "");
    };

    const cancelEditCommentHandler = () => {
        setEditingCommentId(null);
        setEditingCommentText("");
    };

    const saveEditCommentHandler = async (commentId) => {
        const trimmedComment = editingCommentText.trim();

        if (!trimmedComment) {
            return;
        }

        await sendForm({
            body: { text: trimmedComment },
            url: `products/${dataForModal.id}/comments/${commentId}?services=1`,
            method: "PUT",
        }).unwrap();
        await refetchProduct();
        cancelEditCommentHandler();
    };

    const deleteCommentHandler = async (commentId) => {
        if (!window.confirm("Видалити коментар?")) {
            return;
        }

        await sendForm({
            url: `products/${dataForModal.id}/comments/${commentId}?services=1`,
            method: "DELETE",
        }).unwrap();
        await refetchProduct();
        cancelEditCommentHandler();
    };

    return (
        <Modal
            show={showProductModal}
            onHide={handleClose}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Інформація про товар</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {product ? (
                    <div className="modal-container fancybox-content">
                        <div className="modal-content">
                            <div className="modal-body modal-body-noborders">
                                <table className="table table-striped ">
                                    <tbody>
                                        <tr>
                                            <td>Назва</td>
                                            <td className="res_name">{product.title}</td>
                                        </tr>
                                        <tr>
                                            <td>Стан</td>
                                            <td className="res_product_status">{product.status}</td>
                                        </tr>
                                        <tr>
                                            <td>Стан АКБ</td>
                                            <td className="res_product_status">{product.status_battery}%</td>
                                        </tr>
                                        <tr>
                                            <td>IMEI/SN</td>
                                            <td className="res_imei">{product.imei_sn}</td>
                                        </tr>

                                        <tr>
                                            <td>Статус</td>
                                            <td className="res_status">{product.status_shipper}</td>
                                        </tr>
                                        <tr>
                                            <td>Ціна</td>
                                            <td className="res_price">{product.price} грн</td>
                                        </tr>
                                        <tr>
                                            <td>Склад</td>
                                            <td className="res_stock">{product.quantity}</td>
                                        </tr>
                                        <tr>
                                            <td>Магазин</td>
                                            <td className="res_store_name">{product?.store?.title}</td>
                                        </tr>
                                        <tr>
                                            <td>Створено</td>
                                            <td className="res_created">
                                                {moment(product.created_at).format("DD.MM.YYYY HH:MM")}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div
                                    className="res_logs"
                                    id="popup_comments_list"
                                >
                                    <div className="text-left logs_title my-2">
                                        <b>Коментарі</b>
                                    </div>
                                    {comments.length < 1 ? (
                                        <div className="text-muted logs_title">Коментарі відсутні</div>
                                    ) : null}
                                    <table className="table table-striped my-2">
                                        <tbody>
                                            {comments.length > 0
                                                ? comments.map((comment) => {
                                                      return (
                                                          <tr key={comment.id}>
                                                              <td>
                                                                  <div>
                                                                      {comment.user.name}
                                                                      <span className="float-end text-muted">
                                                                          {moment(comment.created_at).format(
                                                                              "DD.MM.YYYY HH:MM",
                                                                          )}
                                                                      </span>
                                                                  </div>
                                                                  {editingCommentId === comment.id ? (
                                                                      <div className="mt-2">
                                                                          <textarea
                                                                              className="form-control"
                                                                              value={editingCommentText}
                                                                              onChange={(e) =>
                                                                                  setEditingCommentText(e.target.value)
                                                                              }
                                                                          />
                                                                          <div className="d-flex justify-content-end gap-2 mt-2">
                                                                              <button
                                                                                  className="btn btn-secondary btn-sm"
                                                                                  onClick={cancelEditCommentHandler}
                                                                              >
                                                                                  Скасувати
                                                                              </button>
                                                                              <button
                                                                                  className="btn btn-primary btn-sm"
                                                                                  onClick={() =>
                                                                                      saveEditCommentHandler(comment.id)
                                                                                  }
                                                                              >
                                                                                  Зберегти
                                                                              </button>
                                                                          </div>
                                                                      </div>
                                                                  ) : (
                                                                      <div className="d-flex justify-content-between gap-2 mt-1">
                                                                          <div>{comment.text}</div>
                                                                          {canManageProductComments ? (
                                                                              <div className="d-flex gap-2">
                                                                                  <button
                                                                                      className="btn btn-outline-secondary btn-sm"
                                                                                      onClick={() =>
                                                                                          startEditCommentHandler(comment)
                                                                                      }
                                                                                  >
                                                                                      Редагувати
                                                                                  </button>
                                                                                  <button
                                                                                      className="btn btn-outline-danger btn-sm"
                                                                                      onClick={() =>
                                                                                          deleteCommentHandler(comment.id)
                                                                                      }
                                                                                  >
                                                                                      Видалити
                                                                                  </button>
                                                                              </div>
                                                                          ) : null}
                                                                      </div>
                                                                  )}
                                                              </td>
                                                          </tr>
                                                      );
                                                  })
                                                : null}
                                        </tbody>
                                    </table>

                                    <div
                                        className=""
                                        style={{ padding: "0 11px" }}
                                    >
                                        <div id="add_comment">
                                            <textarea
                                                className="form-control"
                                                name="text"
                                                data-dl-input-translation="true"
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                            ></textarea>
                                            <div
                                                style={{ padding: "3px 0" }}
                                                className="float-end"
                                            >
                                                <button
                                                    className="btn btn-secondary btn-sm"
                                                    onClick={addCommentHandler}
                                                >
                                                    {isLoading ? "Завантаження" : "Додати коментар"}
                                                </button>
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>
                                    </div>

                                    {/* <div className="res_logs">
                                        <div className="text-left logs_title my-2">
                                            <b>Логи товару</b>
                                        </div>

                                        <table className="table table-striped table-sm no-margin-bottom">
                                            <tbody>
                                                <tr>
                                                    <td>Менеджер</td>
                                                    <td>Склад</td>
                                                    <td className="no-mobile">Магазин</td>
                                                    <td>Майстер</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Система{" "}
                                                        <span
                                                            className="icon icon-sync"
                                                            alt="update_product"
                                                            title="update_product"
                                                        ></span>
                                                        <div className="w_time">2020-12-26 16:35:06</div>
                                                    </td>
                                                    <td className="align-middle"></td>
                                                    <td className="align-middle no-mobile"></td>
                                                    <td className="align-middle">Цимбалюк Максим</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Ярослав Коломієць
                                                        <div className="w_time">2020-11-21 11:04:49</div>
                                                    </td>
                                                    <td className="align-middle">1</td>
                                                    <td className="align-middle no-mobile">Сервісний центр ViFi</td>
                                                    <td className="align-middle"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> */}
                                    <div className="card card-default">
                                        <div className="card-header">Логи товару</div>
                                        <div
                                            className="card-body"
                                            style={{ height: "295px", overflowY: "auto" }}
                                        >
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th className="no-mobile">Менеджер</th>
                                                        <th className="no-mobile">Подія</th>
                                                        <th className="no-mobile">Інформація</th>
                                                        <th className="no-mobile">Дата</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {product?.logs.length > 0 &&
                                                        product.logs.map((log) => {
                                                            return (
                                                                <tr key={log.id}>
                                                                    <td>
                                                                        {log?.user?.name}
                                                                        {/* <div>
                                                            <span className="badge bg-warning text-dark mx-1">
                                                                PC (Windows )
                                                            </span>
                                                            Chrome 75.0.3770.144
                                                        </div> */}
                                                                        <div>
                                                                            <span className="badge bg-secondary ">
                                                                                IP: {int2ip(log.ip)}
                                                                            </span>
                                                                        </div>
                                                                        <div className="on-mobile mt-2">
                                                                            <table className="table table-bordered">
                                                                                <tbody>
                                                                                    {Object.keys(
                                                                                        JSON.parse(log.changes),
                                                                                    ).map((change) => {
                                                                                        return (
                                                                                            <tr key={change}>
                                                                                                <td>{change}</td>
                                                                                                <td>
                                                                                                    {
                                                                                                        JSON.parse(
                                                                                                            log.changes,
                                                                                                        )[change]
                                                                                                    }
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div className="note note-note on-mobile">
                                                                            {logEventList.find(
                                                                                (event) =>
                                                                                    event.evenType === log.event &&
                                                                                    event.logable_type ===
                                                                                        log.logable_type,
                                                                            ).title +
                                                                                " " +
                                                                                moment(log.created_at).format(
                                                                                    "DD.MM.YYYY HH:mm",
                                                                                )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        {
                                                                            logEventList.find(
                                                                                (event) =>
                                                                                    event.evenType === log.event &&
                                                                                    event.logable_type ===
                                                                                        log.logable_type,
                                                                            ).title
                                                                        }
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        <table className="table table-bordered">
                                                                            <tbody>
                                                                                {Object.keys(
                                                                                    JSON.parse(log.changes),
                                                                                ).map((change) => {
                                                                                    return (
                                                                                        <tr key={change}>
                                                                                            <td>{change}</td>
                                                                                            <td>
                                                                                                {
                                                                                                    JSON.parse(
                                                                                                        log.changes,
                                                                                                    )[change]
                                                                                                }
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        {moment(log.created_at).format(
                                                                            "DD.MM.YYYY HH:mm",
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <LoadingModal />
                )}
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    );
};

export default ModalProductInfo;
